import Component from "../component";
import { Duration } from '../countdown/index';
import { Countdown } from '../countdown/index';
const defaultOptions = {
    useApi: true,
    countdownTime: 60,
    pointSize: 50
};
export class PowerSurgeComponent extends Component {
    constructor(powerSurge) {
        super(powerSurge.id);
        this.questionNumber = 0;
        this.answers = [];
        this.getPowerSurgesAvailable = function () {
            let deferred = $.Deferred();
            window.irep.callApi({ url: '/SWIC11/PowerSurges', type: 'POST', data: {} })
                .then((data) => {
                deferred.resolve(data.powerSurges);
            });
            return deferred.promise();
        };
        this.options = defaultOptions;
        this.$powerSurge = $(powerSurge);
        this.$powerSurgeDashboard = this.$powerSurge.find('.swic11-ps-dash');
        this.$powerSurgeDots = this.$powerSurgeDashboard.find('.swic11-ps--dot');
        this.$instructions = this.$powerSurge.find('.swic11-ps--instructions');
        this.$loading = this.$powerSurge.find('.swic11-ps-loading-quiz');
        this.$mapWrapper = this.$powerSurgeDashboard.find('.swic11-ps-dash--wrapper');
        this.$quiz = this.$powerSurge.find('.swic11-ps--quiz');
        this.loadPowerSurges();
        this.$powerSurge.find('.swic11-ps-map-dots').delay(200).fadeIn(600);
    }
    static getTimestamp() {
        if (window.performance && window.performance.now) {
            return window.performance.now();
        }
        else {
            return new Date().getTime();
        }
    }
    setupPowerSurgeBoard(powerSurges) {
        $.each(powerSurges, (i, e) => {
            let $element = $('.swic11-ps-map-dots').find('.show-for-medium').find('.' + e.largeLocation);
            let $smallElement = $('.swic11-ps-map-dots').find('.hide-for-medium').find('.' + e.smallLocation);
            $element.attr('data-quiztype', e.type).data('quiztype', e.type);
            $element.attr('data-available', e.available.toString()).data('available', e.available);
            $element.attr('data-uid', e.uid).data('uid', e.uid);
            $smallElement.attr('data-quiztype', e.type).data('quiztype', e.type);
            $smallElement.attr('data-available', e.available.toString()).data('available', e.available);
            $smallElement.attr('data-uid', e.uid).data('uid', e.uid);
            if (!e.available) {
                $element.attr('data-quiztype', '');
                $element.addClass('completed');
                $smallElement.attr('data-quiztype', '');
                $smallElement.addClass('completed');
            }
            else {
                $element.addClass('available');
                $smallElement.addClass('available');
            }
        });
        this.$powerSurgeDots.show();
    }
    loadPowerSurges() {
        let self = this;
        this.$powerSurgeDots.removeClass('available').attr('data-available', "false").attr('data-uid', "");
        this.$powerSurgeDashboard.fadeIn();
        self.getPowerSurgesAvailable().then((powerSurges) => {
            self.setupPowerSurgeBoard(powerSurges);
        });
        self.$mapWrapper.off().one('click', '.swic11-ps--dot[data-available=true]', (e) => {
            const powerSurgeUid = $(e.target).data('uid');
            $('.swic11-ps--dot, .swicx-orbit--dotnav').fadeOut().promise().then(() => {
                const deferred = $.Deferred();
                self.$powerSurgeDashboard.fadeOut(1000, () => {
                    self.$powerSurgeDashboard.hide();
                    deferred.resolve();
                });
                return deferred.promise();
            }).then(() => {
                this.showOrbitInstruction(powerSurgeUid);
            });
        });
    }
    showOrbitInstruction(powerSurgeUid) {
        let self = this;
        this.$instructions.fadeIn();
        this.$instructions.find('.swic11-ps--footer').off().one('click', 'button', (e) => {
            const role = $(e.target).data('role');
            if (role === "back") {
                self.$instructions.hide();
                self.loadPowerSurges();
            }
            else if (role === "begin") {
                self.startQuiz(powerSurgeUid);
            }
        });
    }
    startQuiz(powerSurgeUid) {
        let self = this;
        self.$instructions.hide();
        this.$loading.show();
        $(".webinar-timer, header, .footer7, footer, nav, .dropdown-pane, .top-bar, .nav-bar, .nav-bar-mobile").hide();
        let $timer = self.$quiz.find('#ps-timer');
        $timer.find('.progress').width(`100%`).removeClass('counting');
        self.getPowerSurgeDetail(powerSurgeUid).then(function (detail) {
            self.$loading.hide();
            self.questionNumber = 0;
            self.answers = [];
            self.powerSurgeDetail = detail.powerSurge;
            self.quizStartTime = PowerSurgeComponent.getTimestamp();
            self.answerTime = self.getQuizTime(self.quizStartTime);
            self.$quiz.find('.indicator').show();
            self.$quiz.find('.question').show();
            self.$quiz.find('.summary').hide();
            self.displayNextQuizQuestion();
            self.$quiz.show();
            let timeLeft = new Duration({ timeSpanString: "", timeSpanNumber: self.options.countdownTime * 1000 });
            self.countdown = self.startCountdown($timer, timeLeft);
        }).fail(() => {
            window.location.reload();
        });
    }
    startCountdown(timecontainer, timeLeft) {
        let self = this;
        const duration = timeLeft.asMilliseconds;
        let $progress = timecontainer.find('.progress');
        $progress.addClass('counting');
        const countdown = new Countdown({ updateTime: 1000, totalTime: duration });
        countdown.start().progress((timings) => {
            let percentage = timings.remaining / (self.options.countdownTime * 10);
            $progress.width(`${percentage}%`);
            timecontainer.attr('data-timespan-ms', timings.remaining);
        }).done((timings) => {
            self.stopQuiz(timings);
        }).fail((timings) => {
            self.stopQuiz(timings);
        });
        return countdown;
    }
    stopQuiz(timings) {
        this.$loading.show();
        this.countdown = null;
        let unanswered = this.powerSurgeDetail.questions.filter((e) => {
            return !this.answers.some((answer) => { return answer.questionId === e.questionId; });
        });
        $.each(unanswered, (i, e) => {
            this.answers.push({ questionId: e.questionId, answerId: 0 });
        });
        return this.startQuizSummary(timings);
    }
    startQuizSummary(timings) {
        let self = this;
        self.$quiz.find('.question').hide();
        self.$quiz.find('.indicator').hide();
        this.postReconResult(timings.trueElapsed).then((result) => {
            let $summary = self.$quiz.find('.summary');
            $summary.find('.total').html(result.total.toString());
            $summary.find('.completed').html(result.completed.toString());
            $summary.find('.correct').html(result.correct.toString());
            $summary.find('.timeTaken').html(Math.round((result.timeTaken / 1000)).toString());
            self.$loading.hide();
            $summary.show();
        });
    }
    postReconResult(time) {
        let deferred = $.Deferred();
        if (this.options.useApi) {
            let data = {
                uid: this.powerSurgeDetail.uid,
                activityUID: this.powerSurgeDetail.activityUID,
                auditUID: this.powerSurgeDetail.auditUID,
                time: time,
                results: this.answers
            };
            window.irep.callApi({ type: 'POST', url: '/SWIC11/PowerSurge/result', data: data }).done((result) => {
                deferred.resolve(result);
            }).fail(() => {
                window.location.reload();
            });
        }
        else {
            deferred.resolve({
                completed: 5,
                correct: 5,
                total: 5,
                timeTaken: 30
            });
        }
        return deferred.promise();
    }
    getPowerSurgeDetail(powerSurgeUid) {
        let deferred = $.Deferred();
        if (this.options.useApi) {
            window.irep.callApi({ url: '/SWIC11/PowerSurge/start', type: 'POST', data: { uid: powerSurgeUid } }).then((data) => {
                deferred.resolve(data);
            }).fail(() => {
                window.location.reload();
            });
        }
        else {
            deferred.resolve(PowerSurgeComponent.multiplechoice);
        }
        return deferred.promise();
    }
    increaseQuizIndicator() {
        this.$quiz.find('.question-counter:not(.completed):first').addClass('completed');
    }
    displayNextQuizQuestion() {
        let question = this.powerSurgeDetail.questions[this.questionNumber];
        let self = this;
        if (question != null) {
            self.$quiz.find('.question').find('.truefalse, .multiplechoice, .select2').empty();
            self.$quiz.find('.question .quiz-question-text').html(question.questionText);
            this.increaseQuizIndicator();
            let $multiplechoice = self.$quiz.find('.multiplechoice');
            $multiplechoice.empty();
            for (let i = 0; i < question.answers.length; i++) {
                let $multiplechoice0 = $('<div/>', { 'data-question-id': question.questionId, 'data-answer-id': question.answers[i].answerId, html: `<div class="button-bg height--100" data-answer-id=${question.answers[i].answerId} data-question-id=${question.questionId}><div data-answer-id=${question.answers[i].answerId} data-question-id=${question.questionId} class="button flexbox--center height--100">${question.answers[i].answerText}</div></div>`, class: "small-12 medium-6 padding-right-for-medium--medium padding-top-for-small-only--medium padding-bottom-for-medium--medium cursor--pointer" });
                $multiplechoice.append($multiplechoice0);
            }
            $multiplechoice.off().one('click', 'div', (e) => {
                let answerId = $(e.target).data('answerId');
                let questionId = $(e.target).data('questionId');
                this.logPowerSurgeAudit(answerId);
                this.answers.push({ questionId: questionId, answerId: answerId });
                this.displayNextQuizQuestion();
                e.stopPropagation();
                e.preventDefault();
                return false;
            });
            ++this.questionNumber;
        }
        else {
            this.countdown.stop();
        }
    }
    getQuizTime(quizStartTime) {
        return Math.round(((PowerSurgeComponent.getTimestamp() - quizStartTime)));
    }
    logPowerSurgeAudit(answerId) {
        let currentTime = this.getQuizTime(this.quizStartTime);
        let answerTime = currentTime - this.answerTime;
        this.answerTime = currentTime;
        return window.irep.callApi({
            url: '/SWIC11/PowerSurge/audit', type: 'POST',
            data: { "auditUID": this.powerSurgeDetail.auditUID, "answerId": answerId, "answerTime": answerTime }
        });
    }
}
PowerSurgeComponent.multiplechoice = {
    type: 'multiplechoice',
    questions: [{
            questionText: 'Which has the fastest speed?',
            questionId: 1,
            answers: [{
                    answerId: 1,
                    answerText: 'Intel Celeron'
                }, {
                    answerId: 2,
                    answerText: 'Intel Core i3'
                }, {
                    answerId: 3,
                    answerText: 'Intel Core i5'
                }, {
                    answerId: 4,
                    answerText: 'Intel Core i7'
                }]
        }, {
            questionText: 'Which has the slowest speed?',
            questionId: 1,
            answers: [{
                    answerId: 1,
                    answerText: 'Intel Celeron'
                }, {
                    answerId: 2,
                    answerText: 'Intel Core i3'
                }, {
                    answerId: 3,
                    answerText: 'Intel Core i5'
                }, {
                    answerId: 4,
                    answerText: 'Intel Core i7'
                }]
        }, {
            questionText: 'Which has the fastest speed?',
            questionId: 1,
            answers: [{
                    answerId: 1,
                    answerText: 'Intel Celeron'
                }, {
                    answerId: 2,
                    answerText: 'Intel Core i3'
                }, {
                    answerId: 3,
                    answerText: 'Intel Core i5'
                }, {
                    answerId: 4,
                    answerText: 'Intel Core i7'
                }]
        }, {
            questionText: 'Which has the slowest speed?',
            questionId: 1,
            answers: [{
                    answerId: 1,
                    answerText: 'Intel Celeron'
                }, {
                    answerId: 2,
                    answerText: 'Intel Core i3'
                }, {
                    answerId: 3,
                    answerText: 'Intel Core i5'
                }, {
                    answerId: 4,
                    answerText: 'Intel Core i7'
                }]
        }, {
            questionText: 'Which has the fastest speed?',
            questionId: 1,
            answers: [{
                    answerId: 1,
                    answerText: 'Intel Celeron'
                }, {
                    answerId: 2,
                    answerText: 'Intel Core i3'
                }, {
                    answerId: 3,
                    answerText: 'Intel Core i5'
                }, {
                    answerId: 4,
                    answerText: 'Intel Core i7'
                }]
        }]
};
const c = {};
$(".swic11-power-surge").each((i, elem) => {
    c[i] = new PowerSurgeComponent(elem);
});
